'use client';

import { useState } from 'react';
import { useWorkflowStore } from '../../../stores/workflowStore';
import { MultiColumnSelector } from '../ColumnSelector';
import { useNodeInputColumns } from '../../../hooks/useNodeInputs';

interface DiffConfigProps {
  nodeId: string;
  config: { keyColumns?: string[]; compareColumns?: string[] };
}

export function DiffConfig({ nodeId, config }: DiffConfigProps) {
  const { updateNodeConfig } = useWorkflowStore();
  const [keyColumns, setKeyColumns]         = useState<string[]>(config.keyColumns     || []);
  const [compareColumns, setCompareColumns] = useState<string[]>(config.compareColumns || []);
  // 合并两个输入节点的列（差异比较取左表字段作为选择依据）
  const inputColumns = useNodeInputColumns(nodeId, 0);

  const save = (updates: Partial<typeof config>) => {
    updateNodeConfig(nodeId, { type: 'diff', params: { keyColumns, compareColumns, ...updates } });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="text-xs font-medium text-zinc-500">主键字段（用于行匹配）</label>
        <MultiColumnSelector values={keyColumns}
          onChange={(cols) => { setKeyColumns(cols); save({ keyColumns: cols }); }}
          columns={inputColumns}
        />
      </div>
      <div className="space-y-2">
        <label className="text-xs font-medium text-zinc-500">比较字段（留空则比较全部列）</label>
        <MultiColumnSelector values={compareColumns}
          onChange={(cols) => { setCompareColumns(cols); save({ compareColumns: cols }); }}
          columns={inputColumns}
        />
      </div>
    </div>
  );
}
